// measurementConfig.ts
import {MeasurementConfig} from './types'
import { CHART_AXIS_CONFIG_FENTON, CHART_AXIS_CONFIG_WHO } from './dataPoints2025';

// measurementConfig.ts
export const MEASUREMENTS_CONFIG: Record<string, MeasurementConfig> = {
    length: {
      id: 'length',
      label: 'אורך',
      unit: 'ס"מ',
      ranges: {
        WHO: { min: 45, max: 95 },
        FENTON: { min: 25, max: 64 }
      },
      axisConfig: {
        WHO: CHART_AXIS_CONFIG_WHO.LENGTH,
        FENTON: CHART_AXIS_CONFIG_FENTON.LENGTH
      }
    },
    head: {
      id: 'head',
      label: 'היקף ראש',
      unit: 'ס"מ',
      ranges: {
        WHO: { min: 33, max: 51 },
        FENTON: { min: 17, max: 44 }
      },
      axisConfig: {
        WHO: CHART_AXIS_CONFIG_WHO.HEAD,
        FENTON: CHART_AXIS_CONFIG_FENTON.HEAD
      }
    },
    weight: {
      id: 'weight',
      label: 'משקל',
      unit: 'ק"ג',
      ranges: {
        WHO: { min: 2, max: 16 },
        FENTON: { min: 0, max: 8 }
      },
      axisConfig: {
        WHO: CHART_AXIS_CONFIG_WHO.WIEGHT,
        FENTON: CHART_AXIS_CONFIG_FENTON.WIEGHT
      }
    }
  };
  